import React from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { GridContextProvider } from '@bingads-webui-grid/grid-context';
import { SelectionMode } from '@fluentui/react';
import { BrandListsDetailsGrid } from './brand-lists-details-grid';

const initialGridContext = {
  selectionMode: SelectionMode.multiple,
};

const getStyles = () => ({
  BrandListsDetailsPage: {
    padding: '25px 32px 0 32px',
  },
});

export const BrandListsDetailsPage = () => {
  const classes = useDefaultStyles(getStyles);

  return (
    <GridContextProvider {...initialGridContext}>
      <div className={classNames('brand-lists-details-page', classes.BrandListsDetailsPage)}>
        <BrandListsDetailsGrid />
      </div>
    </GridContextProvider>
  );
};
